export default __webpack_public_path__ + "static/media/country_background.040a6cc3.png";